import { QueryHookOptions } from "@apollo/client"
import {
  FilterStatusSummaryQuery,
  FilterStatusSummaryQueryVariables,
  useAssignedTripDetailsLazyQuery,
  useAssignedTripSummaryQuery,
  useFilterStatusSummaryQuery,
  useFrontEndTripDetailsLazyQuery,
  useTripRecommendationsLazyQuery,
  useTripStepGraphQuery,
  useTripsForDateLazyQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import useAuth, { useCurrentDepartment, useDeptFrontend } from "hooks/useAuth"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { ApplicationState } from "store"
import { useCurrentDcId } from "store/auth.redux"
import { useTrip } from "../../pages/vehicle/trip/TripContext"

// Queries
export function useAssignedTripSummary() {
  const date = useSelector<ApplicationState>(
    state => state.vehicle.selectedDate
  )

  const dcId = useCurrentDcId()
  const { user } = useAuth()

  return useAssignedTripSummaryQuery({
    variables: {
      departmentId: user?.currentDepartment?.id ?? "",
      distributionCenterId: dcId,
      date,
    },
  })
}

export function useFilterStatusSummary(
  options: QueryHookOptions<
    FilterStatusSummaryQuery,
    FilterStatusSummaryQueryVariables
  >
) {
  const date = useSelector<ApplicationState>(
    state => state.vehicle.selectedDate
  )
  const departmentId = useCurrentDepartment()
  const dcId = useCurrentDcId()
  return useFilterStatusSummaryQuery({
    variables: {
      date,
      distributionCenterId: dcId,
      departmentId,
    },
    ...options,
  })
}

export function useTripStepGraph() {
  const variables = useTripStepGraphVariables()
  return useTripStepGraphQuery({
    variables,
  })
}

export function useTripRecommendations() {
  const isEcommerce = useDeptFrontend()
  // options?: QueryHookOptions<TripRecommendations, TripRecommendationsVariables>
  const { uuid } = useParams<{ uuid: string }>()
  const trip = useTrip()
  const [getRecommendations, { data, loading, error }] =
    useTripRecommendationsLazyQuery({
      variables: {
        uuid: uuid ?? "",

        vehicleLatitude: trip?.lat || 20.1453,
        vehicleLongitude: trip?.lng || 73.8934,
      },
    })
  // Only call this query is the dept is backend
  useEffect(() => {
    if (!isEcommerce) {
      getRecommendations()
    }
  }, [isEcommerce, getRecommendations])

  return {
    data: data?.tripRecommendation?.filter((_, idx) => idx < 5),
    loading,
    error,
  }
}

export function useBackendTripDetails(trip: any) {
  const { uuid } = useParams<{ uuid: string }>()

  return useAssignedTripDetailsLazyQuery({
    variables: {
      vehicleLat: trip?.lat,
      vehicleLon: trip?.lng,
      uuid: uuid ?? "",
    },
  })
}

export function useTripStepGraphVariables() {
  const { uuid } = useParams<{ uuid: string }>()
  const trip = useTrip()
  return {
    uuid,
    vehicleLat: trip?.lat,
    vehicleLon: trip?.lng,
  }
}

export function useFrontendTripDetails() {
  return useFrontEndTripDetailsLazyQuery()
}
export function useTripsForDate() {
  const [{ search, page, date }] = useSearchFilter()
  const [getBackendDetails, responseBackend] = useTripsForDateLazyQuery()

  useEffect(() => {
    const variables = {
      date,
      query: search,
      first: 11,
      skip: page * 11,
    }

    getBackendDetails({ variables })
  }, [search, page, getBackendDetails, date])
  return responseBackend
}
